import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/tags/searchbar";
import TagsTable from "../../../containers/admin/tags/table";
import AddTag from "../../../containers/admin/tags/models/add-tag";
import { getAllTagsRequest } from "../../../modules/admin-modules/tags/Actions";

const Tags = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllTagsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <TagsTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddTag
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Tags;

